import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import OrderBilling from "./OrderBilling";
import OrderProductListItem from "./OrderProductListItem";

const OrderProductList = ({ invoice }) => {
	const {
		orderItems: { nodes: orderItems },
	} = invoice;
	return (
		<div>
			<Table className="simple">
				<TableHead>
					<TableRow>
						<TableCell>Product</TableCell>
						<TableCell align="right">Price</TableCell>
						<TableCell align="right">Quantity</TableCell>
						<TableCell align="right">Total</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{orderItems.map((orderItem, index) => (
						<OrderProductListItem orderItem={orderItem} key={index} />
					))}

					<OrderBilling invoice={invoice} />
				</TableBody>
			</Table>
		</div>
	);
};

export default OrderProductList;
